import { Routes } from "@angular/router";
import { isLoggedIn } from "./common/guards/is-logged-in.guard";

export const appRoutes: Routes = [
  {
    path: "login",
    loadComponent: () => import("./components/auth/login/login.component").then((c) => c.LoginComponent),
  },
  {
    path: "home",
    loadComponent: () => import("./components/auth/login-redirect/login-redirect.component").then((c) => c.LoginRedirectComponent),
  },
  {
    path: "viewer",
    loadComponent: () => import("./components/viewer/viewer.component").then((c) => c.ViewerComponent),
  },
  {
    path: "admin",
    canActivate: [isLoggedIn()],
    children: [      
      {
        path: "home",
        loadComponent: () => import("./components/home/home.component").then((c) => c.HomeComponent),
      },
      {
        path: "accounts",
        loadComponent: () => import("./components/accounts/accounts.component").then((c) => c.AccountsComponent),
      },
      {
        path: "orgs",
        loadComponent: () => import("./components/orgs/orgs.component").then((c) => c.OrgsComponent),
      },    
      {
        path: "users",
        loadComponent: () => import("./components/users/users.component").then((c) => c.UsersComponent),
      },
    ],
  },
  {
    path: "**",
    loadComponent: () => import("./components/auth/login/login.component").then((c) => c.LoginComponent),
  },
];
